export default function lazyImages() {
  const lazyImgs = [].slice.call(document.querySelectorAll('img.lazy-load'));

  if (lazyImgs.length === 0) {
    // console.log("no lazy img found. early return");
    // nothing to do. continue being lazy
    return;
  }

  if ('IntersectionObserver' in window) {
    const lazyImageObserver = new IntersectionObserver(((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImageObserver.unobserve(lazyImage);
          lazyImage.classList.add('lazy-loaded');
        }
      });
    }),
    { rootMargin: '50px' }); // rootMargin allows us to trigger the loading a bit before the elements come into view

    lazyImgs.forEach((lazyImage) => {
      lazyImage.classList.remove('lazy-load');
      lazyImageObserver.observe(lazyImage);
      lazyImage.classList.add('lazy-observed');
    });
  } else {
    // fall back to a more compatible method here
    // immediately load images
    lazyImgs.forEach((lazyImage) => {
      lazyImage.src = lazyImage.dataset.src;
      lazyImage.classList.remove('lazy-load');
    });
  }
}
